export const messagesConstants = {
    FILES_NOT_ACCEPTED: 'Vui lòng chọn file đúng định dạng',
};
